<template>
<!-- 盘点计划 -->
  <div class="liquidationPlan">
    <!-- 搜索 S -->
    <search-panel :fileList="searchFieldList"
                  :data="searchFormInfo.data"
                  :labelWidth="searchFormInfo.labelWidth"
                  :ref-obj.sync="searchFormInfo.ref"
                  :search="() =>getList(1)"
                  style="white-space: nowrap;">
      <template v-slot:form-warehouseCode>
        <warehouse-select style="width: 200px !important" ref="warehouseSelect" :warehouseCode.sync="searchFormInfo.data.warehouseCode"></warehouse-select>
      </template>
    </search-panel>
    <!-- 搜索 E -->
    <!-- 列表 S -->
    <page-table ref='pageTable'
                :list="liquidationPlanList"
                :fieldList="tableFieldList"
                :page="page"
                :size="rows"
                :handleSlot="true"
                :btns="['handle']"
                handelWidth='50'
                :refresh="refresh"
                permission="liquidationPlan">
      <template v-slot:handleSlot="scope">
        <el-button type="text"
                  @click="viewTask(scope.row)"
                  size="small"
                  :disabled="$has('liquidationPlanView')">查看</el-button>
      </template>
      <template v-slot:col-yipCode="scope">
        <el-button type="text"
                  @click="viewTask(scope.row)"
                  size="mini">{{scope.row.yipCode}}</el-button>
      </template>
       <template v-slot:col-yipType="scope">
        <span v-if="scope.row.yipType==1">按商品总数盘点</span>
        <span v-if="scope.row.yipType==2">按货位盘点</span>
        <span v-if="scope.row.yipType==0">按商品货位盘点</span>
      </template>
      <template v-slot:col-taskState="scope">
        <div v-for="(item,index) in liquidationState" :key="index">
          <span v-if="item.value==scope.row.taskState">{{item.label}}</span>
        </div>
      </template>
      <template v-slot:custom-buttons_right>
        <el-dropdown @command="add">
          <el-button type="primary" :disabled="$has('liquidationPlanAdd')">
            +新增盘点计划<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item,index) in liquidationType" :key="index" :command="item.value">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </page-table>
    <!-- 列表 E -->
  </div>
</template>
<script>
import pageTable from '@/components/Table/Index'
import searchPanel from '@/components/Table/SearchPanel'
import assignmentManage from '@/store/assignmentManage/index'
import liquidationManage from '@/store/liquidationManage/index'
import { GETLIQUIDATIONPLAN, ADDPLANCHECK } from '@/store/liquidationManage/types'
import user from '@/store/user/index'
import WarehouseSelect from '@/components/WarehouseSelect.vue'
import { GETHECKED } from '@/store/warehouseTactics/types.js'
let _self
export default {
  name: 'liquidationPlan',
  components: {
    pageTable, searchPanel, WarehouseSelect
  },
  data () {
    return {
      page: 1,
      rows: 10,
      searchFormInfo: {
        data: {
          yipType: '',
          yipSupplierCode: '',
          yipStatus: '',
          createTime: '',
          warehouseCode: ''
        },
        labelWidth: '140px',
        ref: null
      },
      liquidationType: [
        {value: 0, label: '按商品货位盘点'},
        {value: 2, label: '按货位盘点'}
      ], // 盘点类型
      liquidationTypeSelect: [
        {value: 1, label: '按商品总数盘点'},
        {value: 0, label: '按商品货位盘点'},
        {value: 2, label: '按货位盘点'}
      ]
    }
  },
  computed: {
    searchFieldList () {
      return [
        { label: '仓库名称', prop: 'warehouseCode', type: 'slot', labelWidth: '90px' },
        { label: '盘点类型', prop: 'yipType', type: 'select', labelWidth: '90px', options: this.liquidationTypeSelect },
        { label: '供应商', prop: 'yipSupplierCode', type: 'input', labelWidth: '50px' },
        { label: '状态', prop: 'yipStatus', type: 'select', labelWidth: '90', options: this.liquidationState },
        { label: '创建时间', prop: 'createTime', type: 'datePickerRange', labelWidth: '120px' }
      ]
    },
    tableFieldList () {
      return [
        { label: '单据编号', prop: 'yipCode', align: 'center', width: 150, type: 'slot' },
        { label: '盘点类型', prop: 'yipType', width: 150, align: 'center', type: 'slot' },
        { label: '供应商', prop: 'ysName', align: 'center' },
        { label: '盘点库区', prop: 'yaName', width: 120, align: 'center' },
        { label: '状态', prop: 'taskState', width: 120, align: 'center', type: 'slot' },
        { label: '创建人', prop: 'puName', width: 120, align: 'center' },
        { label: '创建时间', prop: 'createTime', width: 180, align: 'center' }
      ]
    },
    // 盘点状态
    liquidationState () {
      return [
        {value: 0, label: '待盘点'},
        {value: 1, label: '盘点中'},
        {value: 2, label: '盘点完成'},
        {value: 3, label: '已取消'}
      ]
    },
    // 用户信息
    userInfo () {
      return user.state.userinfo
    },
    // 列表
    liquidationPlanList () {
      return liquidationManage.state.liquidationPlanList
    },
    // 下拉框 - 供应商
    supplierSelects () {
      return assignmentManage.state.supplierSelects
    }

  },
  watch: {
    'searchFormInfo.data.warehouseCode': function (newVal) {
      if (newVal) {
        this.getCheck(newVal)
      }
    }
  },
  mounted () {
    _self = this
    this.getList()
    // 未开启货位管理时 不显示其他两个类型
    // this.getCheck(this.$refs.warehouseSelect.value)
  },
  methods: {
    getList (page = 1) {
      let {yipType, yipSupplierCode, yipStatus, createTime} = {...this.searchFormInfo.data}
      let params = {
        page: page,
        size: this.rows,
        yipType,
        yipSupplierCode,
        yipStatus,
        createTimeStart: createTime ? createTime[0] : '',
        createTimeEnd: createTime ? createTime[1] : '',
        warehouseCode: this.$refs.warehouseSelect.value
      }
      this.$store.dispatch(GETLIQUIDATIONPLAN, params)
    },
    add (type) {
      let warehouseCode = this.$refs.warehouseSelect.value
      // 当有未完成的按货位或按商品货位盘点计划的时候，不允许新增这两种类型的计划
      if (type === 1) {
        this.$router.push('/liquidationManage/liquidationPlan/addPlanGoods/' + type + '/' + warehouseCode)
        return
      }
      let params = {
        warehouseCode: localStorage.getItem('warehouseCode'),
        yipType: type
      }
      let list = new Promise((resolve, reject) => {
        _self.$store.dispatch(ADDPLANCHECK, params).then(res => {
          if (res.obj && res.obj.code === 502) {
            this.$message({
              message: res.obj.describe,
              type: 'warning'
            })
          } else {
            if (type === 2) {
              this.$router.push('/liquidationManage/liquidationPlan/addPlanLocation/' + type + '/' + warehouseCode)
            } else {
              this.$router.push('/liquidationManage/liquidationPlan/addPlanGoods/' + type + '/' + warehouseCode)
            }
          }
        })
      })
      console.log(list)
    },
    refresh (page, size) {
      this.page = page
      this.rows = size
      this.getList(this.page)
    },
    viewTask (data) {
      this.$router.push('/liquidationManage/liquidationPlanDetail/' + data.yipType + '/' + data.yipCode)
    },
    // 查询是否开启生产日期管理和货位管理
    getCheck (code) {
      let list = new Promise((resolve, reject) => {
        _self.$store.dispatch(GETHECKED, {warehouseCode: code}).then(res => {
          let data = res.obj
          data.forEach(item => {
            if (item.yocOpenType === 1) {
              if (item.yocType) {
                _self.liquidationType = [
                  {value: 0, label: '按商品货位盘点'},
                  {value: 2, label: '按货位盘点'}
                ]
              } else {
                _self.liquidationType = [ {value: 1, label: '按商品总数盘点'} ]
              }
            }
          })
          if ((data.length === 1 && data[0].yocOpenType === 0) || data.length === 0) _self.liquidationType = [ {value: 1, label: '按商品总数盘点'} ]
        })
      })
      console.log(list)
    }
  }

}
</script>
<style>
.liquidationPlan .el-button.el-button--text{
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/liquidationManage/liquidationPlan.vue